"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyThenBy = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyThenBy(factory, src, ascending, selector, comparer) {
    function* generator() {
        for (const pair of src()) {
            yield* (0, utilityFunctions_1.orderByGenerator)(pair, ascending, selector, comparer);
        }
    }
    return factory.createOrderedEnumerable(generator);
}
exports.applyThenBy = applyThenBy;
//# sourceMappingURL=applyThenBy.js.map